import Modal from "react-modal";
import { useState } from "react";
import { useEffect } from "react";
import styled from "styled-components";
import xBtn from "../../image/x.png";
import { useRecoilValue } from "recoil";
import { deviceInfoArrAtom } from "../../recoil/device";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

const DeviceMultiListModal = ({ isOpen, isClose, setSelectedDevice }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedList, setSelectedList] = useState([]);
  const deviceList = useRecoilValue(deviceInfoArrAtom);

  const selectDeviceInModal = (selectedItem) => {
    if (
      selectedItem !== null &&
      (typeof selectedItem === "string" || typeof selectedItem === "number")
    ) {
      if (selectedList.includes(selectedItem)) {
        setSelectedDevice((prev) =>
          prev.filter((item) => item !== selectedItem)
        );
        setSelectedList((prev) => prev.filter((item) => item !== selectedItem));
      } else {
        setSelectedDevice((prev) => [...prev, selectedItem]);
        setSelectedList((prev) => [...prev, selectedItem]);
      }
    } else {
      closeModal();
    }
  };

  useEffect(() => {
    if (isOpen === true) {
      setModalIsOpen(true);
    }
  }, [isOpen]);

  const closeModal = () => {
    setModalIsOpen(false);
    isClose(false);
  };

  const { t } = useTranslation();

  return (
    <Modal
      style={{
        overlay: {
          zIndex: 100,
          width: "100%",
          height: "100vh",
          backgroundColor: "rgba(100, 100, 100, 0.3)",
          transition: "opacity 0.5s ease",
          top: "0",
          position: "fixed",
        },
        content: {
          width: "500px",
          height: "fit-content",
          backgroundColor: "#fff",
          borderRadius: "15px",
          overflow: "hidden",
          position: "absolute",
          left: "50%",
          top: "45%",
          transform: `translate(-50%, -50%)`,
        },
      }}
      isOpen={modalIsOpen}
      onRequestClose={selectDeviceInModal}
      ariaHideApp={false}
      contentLabel="Selected Option"
    >
      <ModalContainer>
        <Title>{t(`select device`)}</Title>
        <span style={{ marginBottom: "20px", fontSize: "1.25rem" }}>
          ( {selectedList?.length} / 10 )
        </span>
        <XBtn onClick={() => closeModal()} />
        <ListContainer>
          {deviceList.map((item, idx) => {
            const isSelected = selectedList.includes(item.serial);
            return (
              <ListItem
                style={{
                  pointerEvents:
                    selectedList && selectedList.length >= 10 && !isSelected
                      ? "none"
                      : "auto",
                }}
                onClick={() => {
                  selectDeviceInModal(item.serial);
                }}
                key={idx}
                isSelected={isSelected}
              >
                {item.serial}
              </ListItem>
            );
          })}
        </ListContainer>
        <div>
          <Button
            variant="contained"
            onClick={() => closeModal()}
            sx={{ marginTop: "10px" }}
          >
            선택 완료
          </Button>
        </div>
      </ModalContainer>
    </Modal>
  );
};

const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Title = styled.h1`
  font-weight: bold;
  font-size: 1.5rem;
  margin-bottom: 10px;
`;

const ListContainer = styled.div`
  width: 400px;
  height: 400px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ListItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 50px;
  padding: 10px 5px;
  margin-bottom: 5px;
  background-color: ${({ isSelected }) => (isSelected ? "#a3f2ff" : "#ebecee")};
  border: 1px solid #d8d8d8;
  cursor: pointer;
  transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  ${
    "" /* &:hover {
    background-color: #cbf1f7;
  } */
  }
`;

const XBtn = styled.img.attrs({
  src: `${xBtn}`,
})`
  width: 25px;
  height: 25px;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 20px;
`;

export default DeviceMultiListModal;
